import {
  formatDateLocalized,
  TimeQuestionConfig,
  TimeResponseState,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import {
  RoutineQuestionMessage,
  RoutineQuestionMessageProps,
} from '../../types';

export const TimeOnlyMessage: RoutineQuestionMessage<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionMessageProps<TimeQuestionConfig, TimeResponseState>
) => {
  const { t } = useTranslation();
  const { response } = props;
  const time =
    typeof response.timeTypeValue === 'string'
      ? formatDateLocalized(response.timeTypeValue)
      : '-';

  return (
    <View>
      <Text style={props.textStyle}>
        {t('routines.time.message.time')}: {time}
      </Text>
    </View>
  );
};
